// dashboard/src/components/billing/WelcomeToPlansCard.tsx
import React from 'react';

const WelcomeToPlansCard: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-100 border border-blue-200 rounded-lg p-8 mb-6">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-blue-500 rounded-full p-3">
            <span className="text-white text-3xl">🚀</span>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-blue-900 mb-3">
          Welcome to Crawly Carl!
        </h2>
        
        <p className="text-blue-800 text-lg mb-6 max-w-2xl mx-auto">
          To get started with our powerful web crawling API, you'll need to choose a subscription plan. 
          Our plans include monthly credit allocations and bonus credits to power your projects.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg p-4 border border-blue-200">
            <div className="text-blue-500 text-2xl mb-2">🔑</div>
            <h3 className="font-semibold text-blue-900 mb-1">API Access</h3>
            <p className="text-sm text-blue-700">Generate API keys and start crawling</p>
          </div>
          
          <div className="bg-white rounded-lg p-4 border border-blue-200">
            <div className="text-green-500 text-2xl mb-2">📊</div>
            <h3 className="font-semibold text-blue-900 mb-1">Analytics</h3>
            <p className="text-sm text-blue-700">Track usage and performance</p>
          </div>
          
          <div className="bg-white rounded-lg p-4 border border-blue-200">
            <div className="text-purple-500 text-2xl mb-2">🛠️</div>
            <h3 className="font-semibold text-blue-900 mb-1">API Playground</h3>
            <p className="text-sm text-blue-700">Test and experiment with our API</p>
          </div>
        </div>

        <div className="bg-white rounded-lg p-6 border border-blue-200 mb-6">
          <h3 className="text-lg font-semibold text-blue-900 mb-4">Why Choose a Plan?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="flex items-start">
              <span className="text-green-500 mr-3 mt-1">✓</span>
              <div>
                <p className="font-medium text-blue-900">Monthly Credits</p>
                <p className="text-sm text-blue-700">Get a fresh allocation every month</p>
              </div>
            </div>
            <div className="flex items-start">
              <span className="text-green-500 mr-3 mt-1">✓</span>
              <div>
                <p className="font-medium text-blue-900">Bonus Credits</p>
                <p className="text-sm text-blue-700">Extra credits included with every plan</p>
              </div>
            </div>
            <div className="flex items-start">
              <span className="text-green-500 mr-3 mt-1">✓</span>
              <div>
                <p className="font-medium text-blue-900">Custom Credits</p>
                <p className="text-sm text-blue-700">Buy additional credits that never expire</p>
              </div>
            </div>
            <div className="flex items-start">
              <span className="text-green-500 mr-3 mt-1">✓</span>
              <div>
                <p className="font-medium text-blue-900">Full API Access</p>
                <p className="text-sm text-blue-700">Unlock all features and endpoints</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-center mb-2">
            <span className="text-orange-500 text-xl mr-2">⚡</span>
            <h4 className="font-semibold text-orange-900">Ready to Get Started?</h4>
          </div>
          <p className="text-sm text-orange-800">
            Choose a plan below to unlock API access, generate your first API key, and start crawling!
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeToPlansCard;
